import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Loader, Title } from '@components/atoms'
import AccordionList from '@components/atoms/Accordion'
import Pagination from '@components/atoms/Pagination'
import SearchInput from '@components/atoms/SearchInput'
import { useInputBounce, useQuery } from '@hooks'
import useFilters from '@hooks/useFilters'
import { disciplinesAPI } from '@services/DisciplinesAPI'

import { disciplineStyles } from './style'

const { container, title, containerAccordion } = disciplineStyles

export const Disciplines = () => {
	const query = useQuery()
	const navigate = useNavigate()

	const pageQuery = Number(query.get('page')) || 1
	const searchQs = query.get('search') || ''

	const [search, setSearch] = useState(decodeURIComponent(searchQs))
	const [searchQuery, setSearchQuery] = useState(decodeURIComponent(searchQs))
	const [page, setPage] = useState(pageQuery)

	const { data, isLoading } = disciplinesAPI.useListQuery({
		page,
		search: encodeURIComponent(searchQuery),
	})

	const searchCallback = useCallback(
		(value: string) => {
			navigate('/disciplinas?page=1')
			setSearchQuery(value)
		},
		[navigate]
	)

	useEffect(() => {
		setPage(pageQuery)
	}, [pageQuery])

	useInputBounce(search, searchCallback)

	useFilters({
		search: searchQuery,
		fallbackUrl: '/disciplinas',
	})

	return (
		<div className={container()}>
			<div>
				<div className={title()}>
					<Title variant='h1' color='$neutral160'>
						Disciplinas
					</Title>

					<SearchInput
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						placeholder='Buscar Disciplina'
						maxLength={30}
						css={{ maxWidth: '100%', '@md': { maxWidth: '287px' } }}
					/>
				</div>

				<div className={containerAccordion()}>
					{isLoading ? (
						<Loader />
					) : (
						<>
							{data?.data && data?.data?.length > 0 ? (
								data.data.map(({ id, name, matters, questionCount }, index) => (
									<AccordionList
										key={index}
										id={id}
										index={page > 1 ? index + 1 + 10 * (page - 1) : index + 1}
										discipline={name}
										matters={matters}
										questionCount={questionCount}
									/>
								))
							) : (
								<p>not</p>
							)}
						</>
					)}
				</div>
				{data?.data && data?.data?.length > 0 && (
					<Pagination pageCount={data?.meta.lastPage || 0} />
				)}
			</div>
		</div>
	)
}
